import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { BlockValues, ComponentMeta } from "../BuilderUI.types";
import { useIsPropertiesPanelRevampEnabled } from "../Hooks/useIsPropertiesPanelRevamp";
import { DefaultEditorCategoryContent } from "./DefaultEditorCategoryContent";
import { DefaultEditorFieldsList } from "./DefaultEditorFieldsList";
import { DefaultEditorTabFields } from "./DefaultEditorTabFields";
import { DefaultEditorV2 } from "./DefaultEditorV2";
import { useCategorizedBlockProps } from "./useCategorizedBlockProps";

export interface DefaultEditorProps {
  block: BaseBlock;
  meta: ComponentMeta;
  values: BlockValues;
}

export const DefaultEditor = ({ meta, block }: DefaultEditorProps) => {
  const { nestedGroups, tabOnlyGroups, unCategorizedProps, tabCategories } =
    useCategorizedBlockProps(meta);
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  if (isPropertiesPanelV2) {
    return <DefaultEditorV2 meta={meta} />;
  }

  if (tabCategories.length > 1) {
    return (
      <DefaultEditorTabFields
        blockId={block.id}
        tabCategories={tabCategories}
        nestedGroups={nestedGroups}
        tabOnlyGroups={tabOnlyGroups}
      />
    );
  }

  if (tabCategories.length === 1) {
    const singleCategory = tabCategories[0];
    return (
      <DefaultEditorCategoryContent
        category={singleCategory}
        nestedGroups={nestedGroups}
        tabOnlyGroups={tabOnlyGroups}
      />
    );
  }

  if (unCategorizedProps.length > 0) {
    return <DefaultEditorFieldsList fields={unCategorizedProps} />;
  }

  return <div />;
};
